import { gql } from 'graphql-request'

export const QueryBlockCrissCross = gql`
  fragment FragmentBlockCrissCross on BlockCrissCrossModelRecord {
          __typename
          anchor
          id
          preface
          title
          headingType
          description {
            value
            links {
              ...FragmentLinkReferences
            }
            blocks {
              id
              file {
                responsiveImage {
                  ...responsiveImageFragment
                }
              }
            }
          }
          orientation
          action {
            ...FragmentNavigationItem
          }
          secondaryAction {
            ...FragmentNavigationItem
          }
          image {
            mimeType
            url
            title
            width
            height
            responsiveImage {
              ...responsiveImageFragment
            }
          }
          wistiaVideo {
            ...QueryVideo
          }
        }
`
export const BlockCrissCross = {
  __typename: 'BlockCrissCross',
  fragmentName: 'FragmentBlockCrissCross',
  fragmentQuery: QueryBlockCrissCross,
  fragments: ['FragmentNavigationItem', 'QueryVideo']
}
